import React from "react";
import cars from "../data/cars";
import "./CarGallery.css";

function CarGallery() {
  return (
    <div className="gallery-container">
      <h1>🚗 Premium Cars Gallery</h1>

      <div className="gallery">
        {cars.map((car) => (
          <div className="card" key={car.id}>
            <img src={car.image} alt={car.name} />
            <div className="card-content">
              <h2>{car.name}</h2>
              <p>{car.price}</p>
              <button>View</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CarGallery;